module.exports = __webpack_public_path__ + "static/assets/6b92aada369c2fc9e71fb49064804850.png";